import {
   createOverviewQueryRestoreGuard,
   skipDefaultFilterGuardsWhenRememberModeOn,
} from '@/core/helpers/remember-last-used-filters.helper';
import EMPLOYER_GUARD from '@/core/guards/employer.guard';
import TEAM_GUARD from '@/core/guards/team.guard';
import type { NavigationGuard } from 'vue-router';

export function contractsOverviewGuards(): NavigationGuard[] {
   return [
      createOverviewQueryRestoreGuard('contractsOverview'),
      skipDefaultFilterGuardsWhenRememberModeOn('contractsOverview', EMPLOYER_GUARD),
      skipDefaultFilterGuardsWhenRememberModeOn('contractsOverview', TEAM_GUARD),
   ];
}
